import React from 'react';

const COOKIE_NOTICE_KEY = 'talixjobs_cookie_notice';

const CookieNotice: React.FC = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const cookieChoice = localStorage.getItem(COOKIE_NOTICE_KEY);
    setVisible(!cookieChoice);
  }, []);

  const handleCookieChoice = (choice: 'accepted' | 'closed') => {
    localStorage.setItem(COOKIE_NOTICE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="card shadow"
      style={{
        position: 'fixed',
        right: '20px',
        bottom: '20px',
        width: 'min(420px, calc(100vw - 24px))',
        zIndex: 1200,
        border: '1px solid rgba(255,255,255,0.15)'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px', alignItems: 'flex-start' }}>
        <div>
          <h3 className="h3" style={{ marginBottom: '8px' }}>Cookie Notice</h3>
          <p className="muted" style={{ margin: 0 }}>
            We use cookies to improve site performance and your browsing experience on talixjobs.
          </p>
        </div>
        <button className="btn ghost" onClick={() => handleCookieChoice('closed')} aria-label="Close cookie notice">
          ✕
        </button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
        <button className="btn" onClick={() => handleCookieChoice('accepted')}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
